export default __webpack_public_path__ + "static/media/searchButtonGreen.1f343707.svg";